import React from 'react';
import { Css, ImageWrap, Markdown } from '../../../../ui';
import styled from '@emotion/styled';
import { ITextSectionEntry } from '../../../shared/api/contentful/types';
import { Section } from './Section';
import { ReadMoreLink } from './ReadMoreLink';
import themed from '../../../../ui/themer/themed';
import { theme } from '../../../shared/styles';
import { Color } from '../../../shared/styles/Color';

const StyledMarkdownWrapper = styled.div`
	a {
		text-decoration: underline;

		&:focus-visible {
			outline: ${theme.button?.primary?.focus?.outline};
			border-radius: 4px;
		}
	}
	table {
		width: 100%;
		border-collapse: collapse;
		margin: ${Css.pxToRem(24)} 0;
	}
	th,
	td {
		border: 1px solid ${Color.TableCellGrey};
		padding: ${Css.pxToRem(12)};
		text-align: left;
		vertical-align: top;
	}

	thead {
		background-color: ${Color.TableHeaderGrey};
		font-weight: bold;
	}
`;

const CustomTextSection = styled(Section)`
	${ImageWrap} {
		img {
			max-width: ${themed(({ layout }) => layout.main.textMaxWidth)};
		}
	}
`;
export interface ITextSectionsProps {
	section: ITextSectionEntry;
}

export const TextSection = ({ section }: ITextSectionsProps) => (
	<CustomTextSection>
		<StyledMarkdownWrapper>
			<Markdown source={section.fields.body} />
		</StyledMarkdownWrapper>
		{section.fields.readMoreLink && (
			<ReadMoreLink link={section.fields.readMoreLink} />
		)}
	</CustomTextSection>
);
